import classes from '@/components/TextField/TextField.module.scss';
import t from '@/utils/Language/UI-translations';

export const CELLPHONE_PLACEHOLDER = '___-___-____';

export const clientSearchTextField = {
  placeholder: t('Client name'),
  type: 'default',
  shape: 'pill',
  subtype: 'left',
  icon: {
    style: 'fas',
    font: 'user',
    additionalSearchBoxIconClass: classes.searchBoxIconClass
  },
  clear: true,
  id: 'searchInput'
};

export const staffSearchTextField = {
  placeholder: t('Search staff'),
  type: 'default',
  shape: 'pill',
  subtype: 'left',
  icon: {
    style: 'fas',
    font: 'user',
    additionalSearchBoxIconClass: classes.searchBoxIconClass
  },
  clear: true,
  id: 'searchInput'
};

export const opportunitySearchTextField = {
  placeholder: t('Search opportunities'),
  type: 'default',
  shape: 'pill',
  icon: {
    style: 'fas',
    font: 'search',
    additionalSearchBoxIconClass: classes.searchBoxIconClass
  },
  clear: true,
  id: 'opportunitySearchInput'
};

export const formatPhoneNumber = (value) => {
  const digits = value.replace(/\D/g, '').slice(0, 10);
  if (digits.length <= 3) return digits;
  if (digits.length <= 6) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
};

export const isValidPhone = (phone) => {
  // Remove anything that's not a number
  phone = phone?.replace(/\D/g, '');
  var re = /^[0-9]+$/;
  return re.test(phone) && phone.length === 10;
};
export const isValidEmail = (email) => {
  var re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return re.test(email);
};
